import { render, staticRenderFns } from "./PricingView.vue?vue&type=template&id=b0d93e74&scoped=true"
import script from "./PricingView.vue?vue&type=script&lang=js"
export * from "./PricingView.vue?vue&type=script&lang=js"
import style0 from "./PricingView.vue?vue&type=style&index=0&id=b0d93e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d93e74",
  null
  
)

export default component.exports